import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { useCheckSpotOnly } from '@flipster/features/src/shared/regulation';
import { FormattedMessage } from '@flipster/i18n';
import DocumentSearchIcon from '@flipster/react/icon/generated/DocumentSearchIcon';
import StarFillIcon from '@flipster/react/icon/generated/StarFillIcon';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

import FavoriteGuide from './assets/favorite_guide.png';
import FavoriteGuideSpotOnly from './assets/favorite_guide_spot_only.png';
import { marketListBunja } from './state';

export const EmptyPlaceholder = () => {
  const { currentTabAtom, searchAtom } = useBunja(marketListBunja);
  const currentTab = useAtomValue(currentTabAtom);
  const search = useAtomValue(searchAtom);

  if (currentTab === 'favorites' && search.trim() === '') return <FavoritesEmptyPlaceholder />;
  return <SearchEmptyPlaceholder />;
};

const SearchEmptyPlaceholder = () => {
  return (
    <div
      className={vstack({
        textStyle: 'Text/S/Regular',
        color: 'content.default.level-2',
        textAlign: 'center',
        gap: 8,
        pt: 38,
      })}
    >
      <DocumentSearchIcon size={48} />
      <p className={css({ whiteSpace: 'pre-line' })}>
        <FormattedMessage id='Common.r250923.No_results_found' />
      </p>
    </div>
  );
};

const FavoritesEmptyPlaceholder = () => {
  const isSpotOnly = useCheckSpotOnly();
  return (
    <div className={vstack({ textAlign: 'center', pt: 38 })}>
      <StarFillIcon size={48} color={token('colors.content.default.level-1')} />
      <h4
        className={css({
          textStyle: 'Title/XS',
          textAlign: 'center',
          color: 'content.default.level-1',
          mt: 16,
        })}
      >
        <FormattedMessage id='Autogen_common.r251126.s_No_favorites_yet' />
      </h4>
      <p
        className={css({
          textStyle: 'Text/M/Regular',
          textAlign: 'center',
          color: 'content.default.level-2',
          whiteSpace: 'pre-line',
          mt: 12,
        })}
      >
        <FormattedMessage id='Trade.r260324.Favorites_can_added_multiline' />
      </p>
      <img
        src={isSpotOnly ? FavoriteGuideSpotOnly.src : FavoriteGuide.src}
        alt='favorite guide'
        width={156}
        height={86}
        className={css({ mt: 32 })}
      />
    </div>
  );
};
